import { Box } from '@mui/material'
import { AspectRatio } from '@radix-ui/react-aspect-ratio'
import NextImage from 'next/image'
import { useMemo } from 'react'
import { DurationLabel } from '~/components/DurationLabel'
import { thumbnailPlaceholder } from '~/libs/constants'
import { Colors } from '~/libs/mui/theme'
import { getVideoWatchedPercent } from '~/libs/video/getVideoWatchedPercent'
import { Video } from '~/types/api/videos'

interface VideoListItemThumbnailProps {
  width: number | 'full'
  video: Video
}

export function VideoListItemThumbnail({ width = 152, video }: VideoListItemThumbnailProps) {
  const percent = useMemo(() => {
    if (video.viewing_status) {
      return getVideoWatchedPercent(
        { minutes: video.duration_min, seconds: video.duration_second },
        { minutes: video.viewing_status.viewing_min, seconds: video.viewing_status.viewing_second },
      )
    }
    return undefined
  }, [video])

  return (
    <Box position='relative' width={width === 'full' ? 1 : width}>
      {/* サムネイル */}
      <AspectRatio ratio={152 / 80}>
        <NextImage
          src={video.landscape_thumbnail_url ?? ''}
          alt={video.title ?? ''}
          fill
          sizes='25vw'
          style={{ objectFit: 'cover', borderRadius: 4 }}
          placeholder='blur'
          blurDataURL={thumbnailPlaceholder}
        />
      </AspectRatio>
      {/* 動画の再生時間 */}
      <Box top='2px' right='2px' position='absolute'>
        <DurationLabel durationMinute={video.duration_min} durationSecond={video.duration_second} />
      </Box>
      {/* 動作の視聴済みバー */}
      {percent !== undefined && (
        <Box
          position='absolute'
          bottom={0}
          left={0}
          height='3px'
          width={`${percent * 100}%`}
          sx={{ backgroundColor: Colors.red, borderRadius: '1px' }}
        />
      )}
    </Box>
  )
}
